<template>
    <AdaptersSidebar
        v-model:visible="model.visible"
        position="left"
        :blockScroll="true"
        :baseZIndex="100000"
        :modal="false"
        :showCloseIcon="false"
        class="menu_mobile__sidebar"
    >
        <template #header>
            <div class="menu_mobile__header">
                <Button
                    icon="pi pi-bars"
                    text
                    class="header_top__menu_button"
                    @click="onToggleMenu"
                />
                <a :href="getMainLink" :title="$t('lang.main.menu_top.main')">
                    <img :src="getLogoLink" :alt="$t('lang.main.menu_top.main')" />
                </a>
            </div>
        </template>
        <MenuItems :isUserAuth="isUserAuth" :isMobile="true" :favoriteItems="favoriteItems" ref="menuItems" :isLeftMenu="isLeftMenu" />
        <div v-if="isUserAuth" @click="onClickSettings" class="menu_mobile__settings_button flex gap-2 align-items-center cursor-pointer">
            <i class="pi pi-ellipsis-h"></i>
            <span>{{ $t('lang.menu.left_menu_label') }}</span>
        </div>
    </AdaptersSidebar>
</template>

<script>
import AdaptersSidebar from "../../adapters/Sidebar.vue";
import MenuItems from "./Items.vue";
import {Listeners} from "../../../constants/listeners";
import Button from "primevue/button";

export default {
    name: "MenuMobile",
    props: {
        isUserAuth: {
            type: Boolean,
            required: true,
        },
        favoriteItems: {
            type: Array,
            required: true,
        },
        isLeftMenu: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            model: {
                visible: false,
            },
        };
    },
    mounted() {
        this.$emitter.on(Listeners.LEFT_MENU_MOBILE_TOGGLE, this.onToggleMenu);
        this.$emitter.on(Listeners.LEFT_MENU_MOBILE_CLOSE, this.onCloseMenu);
    },
    computed: {
        getMainLink() {
            return sprintf('/%s/', window.locale);
        },
        getLogoLink() {
            let date = new Date()
            if ((new Date('2025-11-11T00:00:00+03:00')) < date && date < (new Date('2025-11-14T00:00:00+03:00'))) {
                return '/i/icons/keys11_logo.svg'
            }
            return '/i/icons/logo-light.svg';
        },
    },
    methods: {
        onToggleMenu() {
            this.model.visible = !this.model.visible;
        },
        onCloseMenu() {
            this.model.visible = false;
        },
        onClickSettings() {
            this.$refs.menuItems.onClickSettings();
        },
    },
    components: {
        Button,
        MenuItems,
        AdaptersSidebar,
    }
}
</script>

<style scoped>
.menu_mobile__settings_button {
    padding: 12px 20px;
    margin: 6px 0;
}
.menu_mobile__settings_button i {
    color: #a4b1be;
    font-size: 20px;
}
.menu_mobile__settings_button span {
    color: #ced4da;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.2;
}
</style>

<style>
.menu_mobile__header .header_top__menu_button {
    margin-left: -7px;
    margin-right: 13px;
}
.menu_mobile__sidebar.p-sidebar {
    background-color: #33404D;
    color: #fff;
}
.menu_mobile__sidebar .p-sidebar-header {
    padding: 9px 17px;
}
.menu_mobile__header {
    display: flex;
    align-items: center;
    column-gap: 8px;
}
.menu_mobile__button {
    color: #fff;
}
.menu_mobile__sidebar .p-sidebar-content {
    padding: 0 5px;
    overflow: hidden;
}
.menu_mobile__sidebar .p-panelmenu {
    overflow: hidden;
    padding: 0;
    height: auto;
}
.menu_mobile__sidebar .menu_items__container {
    width: auto;
    position: static;
    height: calc(100vh - 115px);
    overflow: auto;
}
.menu_mobile__sidebar .menu_items__item {
    padding: 12px;
}
/** сработает только тогда, когда поддерживается dvh - высота без учета строки управления и т.д. */
@supports (height: 100dvh) {
    .menu_mobile__sidebar .menu_items__container {
        height: calc(100dvh - 115px);
    }
}
</style>
